var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationDark = function SvgLocationDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1037 17.0507C16.3799 18.9961 14.4511 20.3277 13.547 20.9009C12.6002 21.5013 11.3998 21.5013 10.453 20.9009C9.5489 20.3277 7.6201 18.9961 5.89635 17.0507C5.5793 16.6929 5.26305 16.3073 4.95819 15.8951C4.9447 15.8958 4.93135 15.8966 4.91815 15.8973C4.06248 15.9454 3.26922 16.4188 2.86636 17.2189C2.49253 17.9613 1.97871 19.1271 1.59998 20.5544C1.24831 21.8797 2.23809 23.073 3.53762 23.126C4.98393 23.185 7.58175 23.2502 12.0003 23.2502C16.419 23.2502 19.0168 23.185 20.4631 23.126C21.7627 23.073 22.7524 21.8797 22.4008 20.5544C22.0221 19.1271 21.5082 17.9613 21.1344 17.2189C20.7315 16.4188 19.9383 15.9454 19.0826 15.8973C19.0692 15.8966 19.0556 15.8958 19.0419 15.895C18.737 16.3072 18.4208 16.6929 18.1037 17.0507Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.0349C4 4.59953 7.57955 1 12 1C16.4205 1 20 4.59953 20 9.0349C20 11.8649 18.5708 14.2615 16.981 16.0557C15.3878 17.8538 13.5885 19.0982 12.7437 19.6339C12.2873 19.9233 11.7127 19.9233 11.2563 19.6339C10.4115 19.0982 8.61225 17.8538 7.019 16.0557C5.42925 14.2615 4 11.8649 4 9.0349Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C13.6568 12 15 10.6568 15 9C15 7.34315 13.6568 6 12 6C10.3432 6 9 7.34315 9 9C9 10.6568 10.3432 12 12 12Z",
    fill: "#0F172A"
  })));
};
export default SvgLocationDark;